class DocumentationNew {

    constructor() {

        // Configuraciones
        this.defaultRightScreenSeparation = 15; // Separacion del boton flotante de subir documentacion

        // Tipos de documentos
        this.MY_CONTENT = "MY_CONTENT";
        this.ARTICLE = "ARTICLE";
        this.IMAGE = "IMAGE";
        this.VIDEO = "VIDEO";
        this.DOCUMENT = "DOC";
        this.EXTERNAL = "URL";

        // Estados
        this.displayedDocumentTypes = false;    // Si se esta mostrando o no los tipos de documentos posibles para subir

        // Datos
        this.currentReadingDocument = null; // El id del documento actual que se estaba leyendo en el momento de hacer click sobre el boton + de subir documentacion
        this.lastYScrollPosition = 0;
        this.myContents = new MyContents();
        this.articleDocument = new ArticleDocument();
        this.imageVideoDocument = new ImageVideoDocument();
        this.docDocument = new DocDocument();
        this.externalDocument = new ExternalDocument();

        this._loadEvents();

    }

    _loadEvents() {

        $(document).on("click.toggleDocumentTypes", ".new-document-button:visible", this.onToggleNewButton.bind(this));
        $(document).on("click.SelectDocumentType", ".document-type-button", this.onSelectDocumentType.bind(this));

    }

    getDocumentTypes() {

        return [
            {
                id: this.MY_CONTENT,
                name: Translator.trans("TR_IR_A_BORRADORES"),
                icon: "icoCreateDrafts",
            },
            {
                id: this.ARTICLE,
                name: Translator.trans("TR_ARTICULO"),
                icon: "icoCreateArticle",
            },
            {
                id: this.EXTERNAL,
                name: Translator.trans("TR_EXTERNOS"),
                icon: "icoCreateExternal",
            },
            {
                id: this.IMAGE + "-" + this.VIDEO,
                name: Translator.trans("TR_FOTOS_Y_VIDEO"),
                icon: "icoCreateImage",
            },
            {
                id: this.DOCUMENT,
                name: Translator.trans("TR_DOCUMENTO"),
                icon: "icoCreateDocument",
            },
        ];

    }

    setButtonPosition(folderId, rePositionOnResize) {
        const that = this;
        const newDocumentButton = $("#float-button-new-document-" + folderId);
        const documentTypesContainer = $("#document-type-buttons-container-" + folderId);
        const appWrapper = $(".wrapper").last();
        let rightScreenPosition = this.defaultRightScreenSeparation;

        if ($(window).width() >= 1280) {
            const gapSize = 50; //css grid gap
            const emptyGrid = document.querySelector('.grid__blank__2');

            if (emptyGrid) {
                const {width} = emptyGrid.getBoundingClientRect() || 0;
                rightScreenPosition = width + this.defaultRightScreenSeparation + gapSize;
            }
        } else if ($(window).width() > appWrapper.width()) {
            rightScreenPosition = (($(window).width() - appWrapper.width()) / 2) + this.defaultRightScreenSeparation;
        }

        newDocumentButton.css("right", rightScreenPosition + "px");
        documentTypesContainer.css("right", rightScreenPosition + "px");

        if (rePositionOnResize) {
            $(window).off("resize.floatButtonNewDocument").on("resize.floatButtonNewDocument", function () {
                that.setButtonPosition(folderId, false)
            });
        }
    }

    onToggleNewButton() {

        const body = $("body");
        const modalBackground = $(".uploadModalBackground").last();
        const newButtonIcon = $(".new-document-button > .float-button-icon").last();
        const documentTypesContainer = $(".document-type-buttons-container").last();
        const goUpButton = $(".go-up-button").last();
        const currentReadingDocument = documentationScreenController.documentationScroll.currentReadingDocument;

        // Al clickar en el boton x de cerrar la lista de los tipos de documentos posibles a crear...
        if (this.displayedDocumentTypes) {
            modalBackground.hide(); // ...Se oculta la modal de fondo con fondo oscuro
            documentTypesContainer.hide(); // ...Se oculta la lista con los tipos de documentos que se pueden crear
            newButtonIcon.attr("class", "float-button-icon");    // ...Se devuelve el icono de x a + con una rotacion de 45º
            goUpButton.removeClass("invisible");    // ...Se vuelve a hacer visible el boton de Go Up
            body.removeClass("no-scroll");  // ...Se habilita de nuevo la posibilidad de hacer scroll
            this.displayedDocumentTypes = false;

            // ...Si se estaba leyendo un documento se reanuda la lectura
            if (this.currentReadingDocument) {

                documentationScreenController.documentationProgress.startRead(this.currentReadingDocument);
                documentationScreenController.documentationScroll.currentReadingDocument = this.currentReadingDocument;

                this.currentReadingDocument = null;

            }

            // If module app and editing post out, redirect to home
            const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

            if(isModuleApp && location.href.includes('edit-post')) {
                window.location.href = '/#/';
            }

            // Al clickar en el boton + de abrir la lista de los tipos de documentos posibles a crear...
        } else {
            modalBackground.show(); // ...Se muestra la modal de fondo con fondo oscuro
            documentTypesContainer.show(); // ...Se muestra la lista con los tipos de documentos que se pueden crear
            newButtonIcon.attr("class", "float-button-icon cross-icon"); // ...Se pone el icono de + a x con una rotacion de -45º
            goUpButton.addClass("invisible");   // ...Se oculta el boton de Go Up
            body.addClass("no-scroll"); // ...Se deshabilita la posibilidad de hacer scroll
            this.displayedDocumentTypes = true;

            // ...Si se estaba leyendo un documento se detiene la lectura
            if (currentReadingDocument) {

                const document = documentationScreenController.getDocument(currentReadingDocument);

                if (["AUDIO", "VIDEO"].indexOf(document.type) >= 0) {
                    pauseMedia($(".documentation-advanced-documents-row[data-document=" + document.id + "]").find(document.type)[0]);
                }

                documentationScreenController.documentationProgress.stopRead(currentReadingDocument);

                this.currentReadingDocument = currentReadingDocument;
                documentationScreenController.documentationScroll.currentReadingDocument = null;

            }

        }

    }

    onSelectDocumentType(event) {
        const documentType = $(event.currentTarget).data("type");
        this.lastYScrollPosition = $(window).scrollTop();

        const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

        switch (documentType) {

            case this.MY_CONTENT:
                if (isModuleApp) {
                    this.onToggleNewButton();
                    window.location.href = '/#/my-contents';
                } else {
                    this.myContents.initialize();
                }

                break;
            case this.ARTICLE:
                if (isModuleApp) {
                    this.onToggleNewButton();
                    window.location.href = '/#/article';
                } else {
                    this.articleDocument.initialize();
                }

                break;
            case this.IMAGE + "-" + this.VIDEO:
                if (isModuleApp) {
                    this.onToggleNewButton();
                    window.location.href = '/#/edit-post';
                }

                this.imageVideoDocument.initialize();
                break;
            case this.DOCUMENT:
                if (isModuleApp) {
                    this.onToggleNewButton();
                    window.location.href = '/#/edit-post';
                }

                this.docDocument.initialize();
                break;
            case this.EXTERNAL:
                if (isModuleApp) {
                    this.onToggleNewButton();
                    window.location.href = '/#/external-link';
                } else {
                    this.externalDocument.initialize();
                }
                break;

        }

    }

}
